import {defaultSelectedItem} from "./state";
import {filtro} from "../tipoSeguimiento/state";

export function setListarItems(state, items) {
  state.items = items
}

export function setItem(state, item) {
  state.selectedItem = item
}

// filtro por palabra
export function setFiltro(state, buscar) {
  state.filtro = buscar
}

export function setListarTipoSeguimiento(state, tipoSeguimientos) {
  state.tipoSeguimientos = tipoSeguimientos.map(p => {
    return {value: p.id, label: p.nombre}
  })
}

export function setAccion(state, action) {
  state.accion = action;
}

export function setPage(state, page) {
  state.filtro.page = page
}

export function resetSelectedItem(state) {
  Object.assign(state.selectedItem, defaultSelectedItem())
}

/**
 * Limpiar filtros
 */
export function resetFilters(state) {
  Object.assign(state.filtro, filtro());
}

/**
 * Establecer cargando
 */
export function establecerCargando(state, cargando) {
  state.cargando = cargando
}


